import { render, staticRenderFns } from "./formPhone.vue?vue&type=template&id=30c33410&scoped=true"
import script from "./formPhone.vue?vue&type=script&lang=js"
export * from "./formPhone.vue?vue&type=script&lang=js"
import style0 from "./formPhone.vue?vue&type=style&index=0&id=30c33410&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c33410",
  null
  
)

export default component.exports